import StepId from "@/model/progress/StepId"
import RouteType from "@/model/route/RouteType"
import { providerState, sessionState } from "@/state"

const providerKey = "proceed_standard*"

export default {
    providerKey,

    routes: [
        {
            name: "proceedResumeAfterFullApply",
            path: `/providers/${providerKey}/resume/after-full-apply`,
            meta: { stepper: false },
            redirect: () => {
                let applyResponse = providerState.getApplyResponse(sessionState.providerKey)
                if (
                    applyResponse &&
                    applyResponse.pendingReasons?.length &&
                    applyResponse?.pendingReasons?.includes("additional_documents_needed")
                ) {
                    return `/providers/${providerKey}/terms`
                }

                return `/providers/${providerKey}/paymentPlans`
            },
        },
        {
            name: "proceedOfferReviewNext",
            path: `/providers/${providerKey}/offerReviewNext`,
            redirect: `/providers/${providerKey}/terms`,
        },
        {
            name: "proceedPrequalifyOfferReviewNext",
            path: `/providers/${providerKey}/modes/prequalify/offerReviewNext`,
            meta: { step: StepId.ACCEPT_OFFER },
            redirect: `/providers/${providerKey}/checkCalifornia`,
        },
        {
            name: "proceedPrequalifyTerms",
            path: `/providers/${providerKey}/terms`,
            meta: { step: StepId.ACCEPT_OFFER },
            component: () => import(/* webpackChunkName: "proceed" */ "@/views/provider/proceed/ProceedIframeView"),
        },
        {
            name: "proceedApproved",
            path: `/providers/${providerKey}/approved`,
            meta: { step: StepId.COMPLETE },
            extends: "approved",
            component: () => import("@/views/provider/proceed/ProceedCompleteView"),
        },
        {
            name: "proceedPending",
            path: `/providers/${providerKey}/pending`,
            meta: { step: StepId.COMPLETE, stepper: true },
            extends: "pending",
            component: () => import("@/views/provider/proceed/ProceedCompleteView"),
        },
        {
            name: "proceedResumeFromPrequalifiedReview",
            path: `/providers/${providerKey}/resume/from-prequalified`,
            meta: { step: StepId.PAYMENT_OPTIONS},
            redirect: () => {
                let preauthResponse = providerState.getPreAuthResponse(sessionState.providerKey)
                if (
                    preauthResponse &&
                    preauthResponse.responseCode === "pending" &&
                    preauthResponse.pendingReasons?.length &&
                    (preauthResponse?.pendingReasons?.includes("esign"))
                ) {
                    return `/providers/${providerKey}/terms`
                }

                return `/providers/${providerKey}/paymentPlans`
            },
        },
        {
            //TODO change redirect to work with /prequalified
            name: "proceedResumeFromPaymentPlanReview",
            path: `/providers/${providerKey}/resume/from-payment-plan-review`,
            redirect: `/providers/${providerKey}/paymentPlans`,
            //need to redirect back to plans because of offer_slugs(plan id) updating
        },
    ],
}
